import React from "react";

export default () => {
  return (
    <div className="label-content">
      <h4>Crypto Exchange Settings</h4>
    </div>
  );
};
